import React from 'react';
import '../../../../scss/common/link.scss';
import { observer } from 'mobx-react';
const Link = observer(({
  onClick = null,
  className = '',
  children = [],
  underlined
}) => {
  const onClickLink = e => {
    if (onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClickLink,
    className: `${className} link-cms ${underlined ? '' : 'no-underline'}`
  }, children);
});
export default Link;